
//STYLES
import { Card } from "./style";

//APP
import { leadZero } from "../../../../../../../../utils";

//PROPS
interface Props {
    title: string;
    value: string | number;
    type: string;
    icon: string;
    title_size: number;
    is_highlighted?: boolean;
    onClick: Function;
};

export const CardDetalhe:React.FC<Props> = ({ title, value, type, icon, title_size, is_highlighted, onClick }) => {

    function sizeValue():number {
        if (type==='number') {
            return undefined;
        }
        let qtd_char = String(value).length;
        return 35 - (qtd_char * 1.4);
    }

    return (
        <Card 
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
            data-highlight={is_highlighted}
            onClick={()=>onClick?.()}
            style={{cursor: onClick ? 'pointer' : 'not-allowed'}}
        >
            <p className="Card__title" style={{fontSize: title_size}}>{title}</p>
            <p className="Card__value" style={{fontSize: sizeValue()}}>
                {type==='number' ? leadZero(value) : value}
            </p>

            <img src={icon} className="Card__icon" />
        </Card>
    )
}